import React from "react";
import { LEFT_ARROW } from "../../utils/app-image-contant";
import {  useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/url-constant";
const TopBanner = ({ text, homeText, firstText, secondaryText,thirdText="" }) => {
  const navigation = useNavigate();

  const handleFirstTextClick=()=>{
     if(secondaryText){
      navigation(-1)
     }
  }
  return (
    <>
      <div className="jana_topbanner">
        <div className="">
          <div className="topbannerimg">
            <div className="banner-text">
              <h1 className="text-center px-2" id="spanColor">{text}</h1>
            </div>
            <div id="spanColor" className="secondary-text">
              <span id="spanColor" className="cursor-pointer" onClick={() => navigation(ROUTES.HOME)} >{homeText}</span>
              <img src={LEFT_ARROW} alt="Arrow" className="arrow-icon ms-1" id="spanColor" /> 
              <span className={`cursor-pointer ${!secondaryText && "text-active"}`} onClick={handleFirstTextClick}> {firstText}</span>
              {secondaryText && (
                <>
                  <img
                    src={LEFT_ARROW}
                    alt="Arrow"
                    className="arrow-icon ms-1"
                  />{" "}
                  <span id="spanColor" className="text-active" >{secondaryText}</span>

                </>
              )}
               
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBanner;
